// Layout classes shared by the PR page and its loading fallbacks, so both land
// on the same geometry. Plain module: server fallbacks import it too.

export const PR_V2_CONTENT_CLASS =
  'col-start-1 col-end-13 max-md:px-3 md:col-start-2 md:col-end-10 2xl:mx-auto 2xl:max-w-[1000px] 2xl:w-full';

// Reserve space only while the layout contains a non-empty action bar.
export const PR_V2_MOBILE_ACTION_BAR_HEIGHT_CLASS =
  '[--pr-v2-mobile-action-bar-height:calc(3.5rem+env(safe-area-inset-bottom))] md:[--pr-v2-mobile-action-bar-height:0px] not-has-[[data-pr-v2-mobile-action-bar]:not(:empty)]:[--pr-v2-mobile-action-bar-height:0px]';

// The PR actions list: in the header on desktop, a bottom action bar on phones.
// Hidden when empty (a closed, unmerged PR has no actions) so no blank bar shows.
export const PR_V2_TOP_NAVIGATION_CLASS =
  'inline-flex h-(--header-height) items-center justify-end gap-2 max-md:fixed max-md:inset-x-0 max-md:bottom-0 max-md:z-40 max-md:h-(--pr-v2-mobile-action-bar-height) max-md:border-t max-md:border-border max-md:bg-background max-md:px-3 max-md:pb-[env(safe-area-inset-bottom)] max-md:empty:hidden md:gap-4';
